var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchIconActive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.375 1.5625 2.375 1.5625 4 4 C4 6.66666667 4 9.33333333 4 12 C5.83341465 14.50520579 5.83341465 14.50520579 8 16 C7.67 16.99 7.34 17.98 7 19 C3 17 3 17 1.125 15.875 C-1.08005609 14.79351474 -1.08005609 14.79351474 -4 15.125 C-7 15 -7 15 -9.3125 13.375 C-11.41176127 10.42048414 -12 8.63075827 -12 5 C-8.4759108 -0.46841428 -6.30289394 -1.63875242 0 0 Z M-6.1875 2.625 C-8.10372743 3.87948967 -8.10372743 3.87948967 -9 5.875 C-9.2087703 8.19103164 -9.2087703 8.19103164 -7.3125 10.3125 C-5.18971376 12.23714888 -5.18971376 12.23714888 -2.875 11.875 C-0.81666909 11.04449779 -0.81666909 11.04449779 1 9 C0.99077298 6.45286596 0.99077298 6.45286596 0 4 C-2.34244446 2.14219922 -3.29473397 1.79849542 -6.1875 2.625 Z ",
    fill: "#80BD01",
    transform: "translate(13,2)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchIconActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search-icon-active.e24b0b58bb9242b1ac925d5d9bfd65a0.svg";